type ErrorComponentProps = {
  [prop: string]: unknown;
};

const CustomError = (({ error }: ErrorComponentProps) => {
  console.warn("Render error:", error);
  return <></>;
}) satisfies React.FC<ErrorComponentProps>;

export default CustomError;
